import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Prefrence } from './interfaces';
import { DataService } from './services/data.service';
import { LoggerService } from './services/logger.service';
import { ValidationService } from './services/validation.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PdfGeneratorServiceService } from 'src/app/shared/pdf-generator-service.service';

@Component({
  selector: 'app-pierhippnc',
  templateUrl: './pierhippnc.component.html',
  styleUrl: './pierhippnc.component.css'
})
export class PIERHIPPNCComponent implements OnInit{

  preference: Prefrence | null = null;
  email: string | undefined ='';
  tollfreeNo: string | undefined |  null ='';
  faxNo: string | undefined | null='';
  errorMessageIntialData: string = '';
  address: string='';
  emailTo: string='';
  logoImage: any;
  applicationPDF: any;

  ngOnInit(): void {
   this.logoImage = 'app/module/pierhippnc/assets/img/NCHIPP.jpg';
    this.dataService.getPreference().subscribe({
      next: (preferences: Prefrence) => {
        this.preference = preferences;
        this.faxNo= ValidationService.formatFaxNumber(preferences.preferenceValues?.['FAX_NUM']);
        this.tollfreeNo= ValidationService.formatPhoneNumber(preferences.preferenceValues?.['TOLL_FREE_NUM']);
        this.email= preferences.preferenceValues?.['EMAIL_ID'];
        this.applicationPDF = this.preference.paperApplication;
        this.emailTo='mailto:'+this.email;
        this.address=''+preferences.preferenceValues?.['STATE_PROGRAM']+', '+preferences.preferenceValues?.['ADDRESS1_TXT']+', '+preferences.preferenceValues?.['CITY_TXT']+', '+preferences.preferenceValues?.['STATE_CD']+' '+preferences.preferenceValues?.['ZIP_CODE'];
      }, 
      error:  (err: HttpErrorResponse) => {this.logger.log(err.message);
        const msg = 'Unable to get the Preference details: '+err.message;
        this.errorMessageIntialData = msg;

      }});
    }

  constructor( private route: ActivatedRoute,
    private dataService: DataService,
    private logger: LoggerService,
    private pdfService: PdfGeneratorServiceService
    ) {}

      openPaperApplication(){
      this.pdfService.generatePdf(this.applicationPDF, 'PaperApplication.pdf');
  }

}
